import "./AudioQualityComponent.css";

function AudioQualityComponent({ icon, text, iconColor, contentColor }) {
  return (
    <div
      style={{
        textAlign: "center",
      }}
    >
      <div
        style={{
          color: iconColor,
        }}
      >
        {icon}
      </div>
      <div
        className="audio-quality-text"
        style={{
          color: contentColor,
        }}
      >
        {text}
      </div>
    </div>
  );
}

export default AudioQualityComponent;
